import React, { useEffect, useState } from "react";
import api from "../api";

const CarList = ({ setCarToEdit, refresh }) => {
  const [cars, setCars] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchCars();
  }, [refresh]);

  const fetchCars = async () => {
    setLoading(true);
    try {
      const response = await api.get("/cars");
      setCars(response.data);
    } catch (error) {
      console.error("Failed to fetch cars", error);
    } finally {
      setLoading(false);
    }
  };

  const deleteCar = async (id) => {
    try {
      setLoading(true);
      await api.delete(`/cars/${id}`);
      fetchCars();
    } catch (error) {
      console.error("Failed to delete car", error);
    } finally {
      setLoading(false);
    }
  };

  const buttonStyle =
    "px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition duration-300";

  return (
    <div className="w-full p-6 bg-white rounded-lg shadow-lg">
      <h2 className="text-2xl font-semibold mb-6 text-center">Car List</h2>

      {loading ? (
        <div className="flex flex-col justify-center items-center py-16">
          {/* ДВОЙНОЙ СПИНЕР */}
          <div className="relative w-16 h-16">
            <div className="absolute inset-0 border-4 border-indigo-200 rounded-full"></div>
            <div className="absolute inset-0 border-4 border-transparent border-t-indigo-600 rounded-full animate-spin"></div>
          </div>

          <p className="mt-4 text-sm text-gray-500">
            Загружаем машины...
          </p>
        </div>
      ) : (
        <ul className="space-y-4">
          {cars.map((car) => (
            <li
              key={car._id}
              className="flex justify-between items-center p-4 bg-gray-50 rounded-lg shadow-sm hover:bg-gray-100 transition duration-300"
            >
              <span className="text-lg font-medium">
                {car.make} {car.model} ({car.color}) — {car.owner}
              </span>

              <div className="flex space-x-4">
                <button
                  onClick={() => setCarToEdit(car)}
                  className={buttonStyle}
                >
                  Edit
                </button>
                <button
                  onClick={() => deleteCar(car._id)}
                  className={buttonStyle}
                >
                  Delete
                </button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CarList;
